import $axios from "@/plugins/axios";

/*
  用户登录
  @param {Object} params
*/ 
export const login = params => $axios(
  {
    url: "/v1/passport/login",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '登录中...',
    code_message_show: true,
  },
);
/*
  退出登录
  @param {Object} params
*/ 
export const logout = params => $axios(
  {
    url: "/v1/passport/logout",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '正在退出...',
    code_message_show: true,
  },
);

/*
  找回密码
  @param {Object} params
*/ 
export const findPsw = params => $axios(
  {
    url: "/v1/passport/edit_pwd",
    data: params,
    method: 'POST',
  },
  {
    code_message_show: true,
  },
);
/*
  修改密码
  @param {Object} params
*/ 
export const editPsw = params => $axios(
  {
    url: "/v1/passport/login_edit_pwd",
    data: params,
    method: 'POST',
  },
  {
    code_message_show: true,
  },
);
/*
  用户注册
  @param {phone} string|number
  @param {captcha} string|number
  @param {password} string|number
  @param? {openid} string
*/ 
export const register = params => $axios(
  {
    url: "/v1/passport/register",
    data: params,
    method: 'POST',
  },
  {
    loading: true,
    loadingMsg: '注册中...',
    code_message_show: true,
  },
);
/*
  发送验证码
  @param {Object} params
*/ 
export const send_sms = params => $axios(
  {
    url: "/v1/passport/send_sms",
    data: params,
    method: 'POST',
  },
  {
  },
);